import { MessageReader } from "@foxglove/rosmsg2-serialization";
import type { MessageDefinition } from "@foxglove/message-definition";

const HEADER_DEF: MessageDefinition = {
    name: "std_msgs/Header",
    definitions: [
        { type: "builtin_interfaces/Time", name: "stamp", isComplex: true },
        { type: "string", name: "frame_id" },
    ],
};

const TIME_DEF: MessageDefinition = {
    name: "builtin_interfaces/Time",
    definitions: [
        { type: "int32", name: "sec" },
        { type: "uint32", name: "nanosec" },
    ],
};

const COMPRESSED_IMAGE_DEFS: MessageDefinition[] = [
    {
        definitions: [
            { type: "std_msgs/Header", name: "header", isComplex: true },
            { type: "string", name: "format" },
            { type: "uint8", name: "data", isArray: true },
        ],
    },
    HEADER_DEF,
    TIME_DEF,
];

const compressedImageReader = new MessageReader(COMPRESSED_IMAGE_DEFS);

type CborRawEnvelope = { secs: number; nsecs: number; bytes: Uint8Array };

export function isCborRawMessage(msg: unknown): msg is CborRawEnvelope {
    if (msg == null || typeof msg !== "object") return false;
    const m = msg as Record<string, unknown>;
    return (
        typeof m.secs === "number" &&
        typeof m.nsecs === "number" &&
        m.bytes instanceof Uint8Array
    );
}

export function deserializeCompressedImage(bytes: Uint8Array) {
    return compressedImageReader.readMessage<{
        header: { stamp: { sec: number; nanosec: number }; frame_id: string };
        format: string;
        data: Uint8Array;
    }>(bytes);
}
